import React, { useContext, useEffect, useRef, useState } from "react";

import {
  BookOpenIcon,
  CalendarIcon,
  ChevronRight,
  ClockIcon,
  Search,
} from "lucide-react";

import { UserContext, useUserContext } from "../../../context/UserContext";
import toast from "react-hot-toast";
import {
  CancellationReasonTypes,
  ExamsDetailsTypes,
  ExamsTypes,
} from "../../../interfaces/exams.interface";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseServiceUrl, urls } from "../../../environment";
import { FeatureCard } from "../FeatureCard";
import { ExaminationSlide } from "../ExaminationSlide";

import { Calendar } from "../home/Calendar";
import ResultQAReport from "../ResultQAReport";
import {
  convertTo12Hour,
  decryptAES256CBC,
  decryptAES256CBC2,
  encryptWithFixedKey,
  formatDateTime,
  generateRandomBytes,
  startClockFromInput,
} from "../../../utils";
import PageLoader from "../../../components/Loader/PageLoader";

import moment from "moment";
import useUserStore from "../../../stores/useUserStores";
import useExamStores from "../../../stores/useExamStores";

const ExaminationDashboard: React.FC = () => {
  const CurrentTimerRef = useRef<any>(null);
  const location = useLocation();
  const TimeMountRef = useRef<boolean>(false);
  const errornotify = (msg: any) => toast.error(msg);

  const [examsets, setexamsets] = useState<ExamsTypes>({
    count: 0,
    page_index: 0,
    page_size: 0,
    resp: [],
    current_datetime: "",
  });
  const Navigate = useNavigate();

  const {
    userdetail,
    setLoading,
    token,
    fullscreenmode,
    setFullScreenMode,
    setExam,
    exam,
    setExamStarted,
    examStarted,
    examQuestionDetails,
    setExamQuestionDetails,
    setStartExamMessage,
    loading,
    startExamMessage,

    resumeDuration,
    setResumeDuration,
  } = useUserStore();
  const { handleFullscreenChange, enterFullscreen }: any = useUserContext();
  const ExamContext = useExamStores();
  // const [currentTime, setCurrentTime] = useState<{
  //   date: string;
  //   time: string;
  // }>({
  //   date: "",
  //   time: "",
  // });

  const [currentTime, setCurrentTime] = useState<{
    date: string;
    time: string;
  }>({
    date: "",
    time: "",
  });

  const [cancellationDetails, setCancellationDeatails] = useState<
    Array<CancellationReasonTypes>
  >([]);

  const [selectedExamForScrutiny, setSelectedExamForScrutiny] = useState<
    ExamsDetailsTypes | undefined | null
  >(null);

  const getAllExams = async () => {
    try {
      setLoading(true);

      const response = await axios.post(
        baseServiceUrl + urls.getAllExamUrl,
        {
          search_string: "SA",
          page_index: 0,
          page_size: 6,
          user_type: "Examinee",
          user_id: userdetail.id,
          email: userdetail.email,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      if (response.data) {
        setexamsets(response.data);
      }

      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      errornotify(
        err?.response?.data?.message || "Error encounter. Please try again."
      );
    }
  };

  useEffect(() => {
    if (!userdetail) return;
    (() => getAllExams())();
  }, [userdetail]);

  // useEffect(() => {
  //   if (userdetail && examsets.resp.length > 1) {
  //     window.addEventListener("focus", () => {
  //       getAllExams();
  //     });
  //   }
  // }, [userdetail, examsets]);

  const getNewExams = () => {
    return examsets && examsets?.resp ? examsets.resp : [];
  };
  // const getPublishedResult = () => {
  //   return examsets && examsets?.resp
  //     ? examsets.resp
  //         .filter((self: any) => self.status === "PUBLISHED")
  //         .slice(0, 3)
  //     : [];
  // };

  //  *************************  Resume Test ************************************
  const resumeTest = (item: any) => {
    (async () => {
      try {
        const encryption_key = generateRandomBytes();
        setLoading(true);
        let rawPayload = {
          exam_id: item.id,
          user_id: userdetail.id,
          encryption_key,
          face_verified: ExamContext.faceVerfied,
        };
        const payload = encryptWithFixedKey(rawPayload);
        const response = await axios.post(
          baseServiceUrl + urls.resumeExam,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response.data) {
          const rawResponse = await decryptAES256CBC2(
            response.data?.response,
            btoa(encryption_key)
          );
          const responsedData = JSON.parse(rawResponse);
          if (responsedData?.proctor_token) {
            ExamContext.setProctorAuthToken(responsedData?.proctor_token ?? "");
          }
          enterFullscreen?.();
          handleFullscreenChange?.();

          setExamStarted(true);
          setStartExamMessage(
            responsedData?.message ?? "Examination resumed successfully"
          );

          setExam({
            ...exam,

            ...item,
            exam_session: responsedData?.session_id,
          });

          //  ToDo:// *************************************   need to discuss with sajal daa *********************************************
          if (responsedData && responsedData?.duration)
            setResumeDuration(responsedData?.duration);
          if (
            responsedData &&
            responsedData.questions &&
            Array.isArray(responsedData?.questions)
          ) {
            const _tempQuestions = responsedData.questions.map((self: any) => ({
              ...self,
              ans_id: self?.selected_option,
              status: self?.question_status,
            }));
            const _tempDetails = JSON.parse(
              JSON.stringify({ ...responsedData, questions: _tempQuestions })
            );
            setExamQuestionDetails(_tempDetails);
          } else {
            setExamQuestionDetails(responsedData);
          }
          Navigate("/test/ongoing");
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };

  // **********************  Start Test ***********************************

  const startTest = (item: any) => {
    const encryption_key = generateRandomBytes();
    (async () => {
      try {
        setLoading(true);
        let rawPayload = {
          exam_id: item.id,
          user_id: userdetail.id,
          encryption_key,
          face_verified: ExamContext.faceVerfied,
        };

        const payload = encryptWithFixedKey(rawPayload);

        const response = await axios.post(
          baseServiceUrl + urls.examStartUrl,
          payload,
          {
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );

        if (response.data) {
          const rawResponse = await decryptAES256CBC2(
            response.data?.response,
            btoa(encryption_key)
          );
          const responsedData = JSON.parse(rawResponse);

          if (responsedData?.proctor_token) {
            ExamContext.setProctorAuthToken(responsedData?.proctor_token ?? "");
          }
          enterFullscreen?.();
          handleFullscreenChange?.();

          setExamStarted(true);
          setStartExamMessage(
            responsedData?.message ?? "Examination started successfully"
          );

          setExam({
            ...exam,
            ...item,
            exam_session: responsedData?.session_id,
          });
          setExamQuestionDetails(responsedData);
          Navigate("/test/ongoing");
        }

        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        errornotify(
          err?.response?.data?.message || "Error encounter. Please try again."
        );
      }
    })();
  };

  useEffect(() => {
    if (examsets.current_datetime && !TimeMountRef.current) {
      TimeMountRef.current = true;

      const result = formatDateTime(examsets.current_datetime);

      setTimeout(() => {
        setCurrentTime(result);
      }, 2000);
    }
  }, [examsets]);

  useEffect(() => {
    if (currentTime?.date && currentTime?.time) {
      CurrentTimerRef.current = startClockFromInput({
        input: currentTime,
        setInput: setCurrentTime,
      });

      // return () => {
      //   if (timer) clearInterval(timer);
      // };
    }
  }, [examsets, currentTime.date]);

  useEffect(() => {
    if (location.pathname !== "/dashboard") {
      if (CurrentTimerRef.current) {
        clearInterval(CurrentTimerRef.current);
      }
    }
  }, [location.pathname]);

  if (loading) return <PageLoader loading />;
  return (
    <div className="space-y-8 w-full min-h-[90vh]  overflow-auto  pb-5   ">
      <ResultQAReport
        examsDetailsTypes={selectedExamForScrutiny}
        handleClose={() => setSelectedExamForScrutiny(null)}
        cancellationDetails={cancellationDetails}
        setCancellationDeatails={setCancellationDeatails}
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:mx-4 mt-4">
        <div className="md:col-span-2">
          <FeatureCard
            title="Introduction & Basics"
            description="Learn all the basics that you need to know to get started."
            buttonText="Join now"
            bgColor="bg-emerald-50"
            textColor="text-emerald-800"
            buttonColor="bg-emerald-600 hover:bg-emerald-700 text-white"
          />
        </div>
        <div className="md:col-span-1">
          <Calendar />
        </div>
      </div>

      <div className="grid grid-cols-12">
        <div className="col-span-12">
          <div className="w-full lg:px-4 px-1">
            {/* Header */}
            <div className="w-full bg-white rounded-lg border border-gray-100 shadow-xs p-5">
              <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
                {/* Left Content */}
                <div className="flex items-start space-x-4">
                  {/* Icon */}
                  <div className="mt-1 p-2.5 bg-blue-50 rounded-lg">
                    <BookOpenIcon className="h-5 w-5 text-blue-600" />
                  </div>

                  <div>
                    {/* Title */}
                    <div className="flex items-center gap-x-2">
                      <h2 className="text-xl font-semibold text-gray-900">
                        New Exams
                      </h2>
                      <span className="inline-flex items-center rounded-full bg-green-50 px-2.5 py-1 text-xs font-medium text-green-700">
                        {getNewExams().length} Exams Available
                      </span>
                    </div>

                    {/* Info Row */}
                    <div className="mt-2 flex flex-wrap items-center gap-3">
                      {/* Date */}
                      {examsets.current_datetime && currentTime?.date ? (
                        <div className="flex items-center space-x-1.5">
                          <CalendarIcon className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-600">
                            {examsets.current_datetime && currentTime?.date
                              ? currentTime?.date
                              : ""}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}

                      {/* Time */}
                      {examsets.current_datetime && currentTime?.time ? (
                        <div className="flex items-center space-x-1.5">
                          <ClockIcon className="h-4 w-4 text-gray-400" />
                          <span className="text-sm text-gray-600">
                            {convertTo12Hour(
                              currentTime?.time.replace(/AM|PM/, "")
                            )}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}

                      {/* Exams Badge */}
                    </div>
                  </div>
                </div>

                {/* CTA Button */}
                <button
                  onClick={() => Navigate(`/dashboard/my-exams`)}
                  className="inline-flex items-center space-x-1 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none"
                >
                  <span>View All</span>
                  <ChevronRight className="h-4 w-4" />
                </button>
              </div>
            </div>

            {/* Premium Card Grid */}
            <div className="bg-gray-50/50 lg:px-5 py-6 rounded-b-lg border border-gray-100 border-t-0">
              {getNewExams().length > 0 ? (
                <div className="grid grid-cols-1 xs:grid-cols-12 lg:grid-cols-12 gap-5">
                  {getNewExams().map((exam: any, index: number) => (
                    <ExaminationSlide
                      key={exam.id || index}
                      details={exam}
                      indexNum={index + 1}
                      startTest={startTest}
                      resumeTest={resumeTest}
                      currentDateTime={examsets.current_datetime}
                      currentTime={currentTime}
                    />
                  ))}
                </div>
              ) : (
                /* No Found */
                <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
                  <div className="mb-5 p-4 bg-gray-100 rounded-full">
                    <Search className="h-8 w-8 text-gray-400" />
                  </div>
                  <h3 className="text-lg font-medium text-gray-800">
                    No exams available
                  </h3>
                  <p className="text-gray-500 mt-2 max-w-md text-sm">
                    There are currently no new exams.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExaminationDashboard;
